import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { spreadTypography } from '../../../../utils/typeUtils';
export const Wrapper = styled(Box)(({
  theme
}) => ({
  color: theme.palette.grey[800],
  ...spreadTypography(theme.typography['Lato Body 2'])
}));
export const Value = styled(Typography)(({
  theme
}) => ({
  display: 'inline',
  ...spreadTypography(theme.typography['Lato Emphasized 2'])
}));